import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {selectFamilyConfig, selectRegion} from '../selectors';

// https://alpha.salesconfigurator.selux.cloud.ceventis.de/api/product-data-provider/v1/price/data

export const fetchPrice = createAsyncThunk(
	'price/priceLoading',
	(options, {getState}) => {
		const model = selectFamilyConfig(getState()).model;
		const region = 'DEU'; // selectRegion(getState());
		const customerType = 'None';
		return superagent
			.post(`${getState().status.priceUrl}/calculation?dateTime=${options.datetime}&configurationModelId=${model}&countryIso3Code=${region}&customerType=${customerType}`)
			.send(options.attributes)
			.set('X-API-KEY', 'bQXBsmDsFgKgt7f1bK88JEwgHXCTaK3JZt6c8TrqwjqNlnbQ6s') // TODO replace with proxy
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error);
	}
);

export const fetchPriceData = createAsyncThunk(
	'price/fetchPriceData',
	(options, {getState}) =>
		superagent
			.get(`${getState().status.pimUrl}/price/data`)
			.set('X-API-KEY', 'pmdGQ96nFoO1XfGQq9aNkIcFHUBjcJ35FTQ7JjBsggReR7OZSZ') // TODO replace with proxy
			.set('Accept', 'application/json')
			.then((response) => response.body)
			.catch((error) => error)
);

const priceInitialState = {
	status: 'idle',
	data: {},
	priceData: {},
	error: {},
};
export const priceSlice = createSlice({
	name: 'price',
	initialState: priceInitialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchPrice.fulfilled, (state, action) => {
			state.data = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchPrice.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchPrice.rejected, (state, action) => {
			state.data = {};
			state.status = 'idle';
			state.error = action.payload;
		});
		builder.addCase(fetchPriceData.fulfilled, (state, action) => {
			state.priceData = action.payload;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(fetchPriceData.pending, (state, action) => {
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(fetchPriceData.rejected, (state, action) => {
			state.priceData = {};
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});


export const {} = priceSlice.actions;


export default priceSlice.reducer;
